/**
 * Shared model registry — fetches model metadata from the /models API
 * and caches it in memory for the session.
 */

let _cache = null;

/**
 * Fetch the model registry from the backend.
 * Returns an array of { id, provider, display_name, context_tier }.
 * Results are cached after the first successful call.
 */
export async function fetchModelRegistry(apiBaseUrl) {
  if (_cache) return _cache;
  try {
    const res = await fetch(`${apiBaseUrl}/models`);
    _cache = res.ok ? await res.json() : [];
  } catch {
    _cache = [];
  }
  return _cache;
}

/**
 * Look up a human-readable display name for a model ID.
 * Falls back to the raw model ID if not found in the registry.
 *
 * @param {Array} models - The model registry array from fetchModelRegistry()
 * @param {string} modelId - e.g. "openai:gpt-5"
 * @returns {string} e.g. "OpenAI GPT 5"
 */
export function getModelDisplayName(models, modelId) {
  if (!models || !modelId) return modelId || '';
  const entry = models.find((m) => m.id === modelId);
  return entry?.display_name || modelId;
}

/**
 * Reset the cache (useful for testing or after config changes).
 */
export function resetModelCache() {
  _cache = null;
}
